"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSessionData = exports.default = void 0;
var _react = require("react");
var _useScripts2 = require("./useScripts");
var _urls = require("../utilities/urls");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TIMEOUT_INTERVAL = 500;
var extendSessionTimer;
var extendEventName = 'mousedown';
if ('ontouchstart' in document.documentElement) {
  extendEventName = 'touchstart';
}
var useScriptsList = {
  scriptsList: [{
    src: "".concat(_urls.apiGatewayUrl, "/accessmngapi/provider/accessmanagement.js"),
    isWaitUntilLoaded: false,
    checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
      return window.cet && window.cet.accessmanagement;
    }
  }]
};
var useSessionData = function useSessionData() {
  var _useScripts = (0, _useScripts2.useScripts)(useScriptsList),
    isReady = _useScripts.isReady,
    error = _useScripts.error;
  var _useState = (0, _react.useState)({
      isSessionDataReady: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    sessionData = _useState2[0],
    setSessionData = _useState2[1];
  (0, _react.useEffect)(function () {
    var isActive = true;
    var isListening = false;
    var getSessionData = function getSessionData() {
      if (isActive && window.cet && window.cet.accessmanagement) {
        window.cet.accessmanagement.getSessionAsync().then(function (sessionData) {
          if (isActive) {
            setSessionData(sessionData ? _objectSpread(_objectSpread({}, sessionData), {}, {
              isSessionDataReady: true
            }) : {
              isSessionDataReady: true
            });
          }
        });
      }
    };
    var extendSession = function extendSession() {
      window.clearTimeout(extendSessionTimer);
      extendSessionTimer = setTimeout(function () {
        window.cet.accessmanagement.extendSessionAsync();
      }, TIMEOUT_INTERVAL);
    };
    if (isReady && !error) {
      isListening = true;
      document.addEventListener('cet.accessmanagement.login', getSessionData);
      document.addEventListener('cet.accessmanagement.logout', getSessionData);
      document.addEventListener('cet.accessmanagement.sessionchange', getSessionData);
      window.addEventListener(extendEventName, extendSession);
      // window.addEventListener('resize', extendSession, {passive: true});

      getSessionData();
    }
    return function () {
      isActive = false;
      if (isListening) {
        document.removeEventListener('cet.accessmanagement.login', getSessionData);
        document.removeEventListener('cet.accessmanagement.logout', getSessionData);
        document.removeEventListener('cet.accessmanagement.sessionchange', getSessionData);
        window.removeEventListener(extendEventName, extendSession);
        // window.removeEventListener('resize', extendSession);
      }
    };
  }, [isReady, error]);
  return sessionData;
};
exports.useSessionData = useSessionData;
var _default = useSessionData;
exports.default = _default;